'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Cell;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function CellValue(_ref) {
  var CellComponent = _ref.component,
      value = _ref.value;

  if (CellComponent) {
    return _react2.default.createElement(CellComponent, {
      value: value
    });
  }

  return value;
}

CellValue.propTypes = {
  component: _propTypes2.default.func,
  value: _propTypes2.default.any
};
CellValue.defaultProps = {
  component: undefined,
  value: undefined
};

function Cell(props) {
  var header = props.header,
      component = props.component,
      value = props.value,
      isFirst = props.isFirst;

  var getHeaderLabel = function getHeaderLabel() {
    if (typeof header === 'string') {
      return header;
    }

    return undefined;
  };

  if (isFirst) {
    return _react2.default.createElement('th', {
      className: 'rainbow-table_cell-container',
      scope: 'row',
      tabIndex: -1,
      'data-label': getHeaderLabel()
    }, _react2.default.createElement('div', {
      className: 'rainbow-table_cell-content'
    }, _react2.default.createElement(CellValue, {
      component: component,
      value: value
    })));
  }

  return _react2.default.createElement('td', {
    className: 'rainbow-table_cell-container',
    role: 'gridcell',
    tabIndex: -1,
    'data-label': getHeaderLabel()
  }, _react2.default.createElement('div', {
    className: 'rainbow-table_cell-content',
    role: 'presentation'
  }, _react2.default.createElement(CellValue, {
    component: component,
    value: value
  })));
}

Cell.propTypes = {
  header: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  component: _propTypes2.default.func,
  value: _propTypes2.default.any,
  isFirst: _propTypes2.default.bool
};
Cell.defaultProps = {
  header: undefined,
  component: undefined,
  value: undefined,
  isFirst: false
};